<template>
  <div>
    <div class="mt-2">
      <button type="button" class="btn btn-sm btn-outline-primary" @click="showModal = true">
        <i class="fa fa-plus-circle" aria-hidden="true"></i>
        {{ $t('Add activity') }}
      </button>
    </div>
    <OrderItemActivityVariantModal
        :update-item-url="addItemUrl"
        :show-modal="showModal"
        :activities-url="activitiesUrl"
        @exit-modal="showModal = false"
        @modal-close="showModal = false"
    ></OrderItemActivityVariantModal>
  </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import OrderItemActivityVariantModal from "@/components/orders/OrderItemActivityVariantModal.vue";

const props = defineProps({
  addItemUrl : {
    required: true,
    type: String,
  },
  activitiesUrl : {
    required: true,
    type: String,
  },
})

const showModal = ref(false);

</script>

